<template>
    <div>
        <div v-if="subscriptions">
            <div v-if="subscriptions.length > 0">
                <b-row>
                    <b-col v-for="(group, orderNo) in groupedSubscriptions" :key="orderNo">
                        <b-card>
                            <b-row>
                                <b-col v-for="subscription in group" :key="subscription.uuid" cols="12">
                                   
                                    <b-col cols="12"  class="mb-4">{{ $t('service') }} : {{ subscription.license_product.name }} 
                                        <protokol-settings-dropdown size="sm" class="pull-right">
                                            <b-dropdown-item-button @click="cancel(subscription.licenes_code)" v-if="canCancel(subscription)"> {{ $t('cancel') }} </b-dropdown-item-button>
                                            <b-dropdown-item-button variant="success" @click="renew(subscription.license_code)" v-if="canRenew(subscription)"> {{ $t('renew') }} </b-dropdown-item-button>
                                            <b-dropdown-item-button variant="danger" @click="remove(subscription.license_code)" v-if="canRemove(subscription)"> {{ $t('remove') }} </b-dropdown-item-button>
                                        </protokol-settings-dropdown>
                                    </b-col>

                                    <div v-if="subscription.payment_status">
                                            <b-col xs="6">
                                                {{ $t('paymentStatus') }}: {{ subscription.payment_status }}
                                                <br />

                                                {{ $t('status') }}:
                                                <b-badge variant="success" v-if="subscription.is_active"> {{ $t('active') }} </b-badge>
                                                <b-badge variant="warning" v-if="subscription.is_expired"> {{ $t('expired') }} </b-badge>
                                                <b-badge variant="warning" v-if="subscription.is_trial"> {{ $t('trial') }} </b-badge>
                                                <b-badge variant="danger" v-if="!subscription.is_active"> {{ $t('notActive') }} </b-badge>

                                                <template v-if="subscription.is_expired">
                                                    <template v-if="subscription.payment_provider != 'protokol'">
                                                        
                                                    </template>
                                                </template>

                                                <template v-else>

                                                    <template v-if="!subscription.is_active">
                                                        <b-badge variant="danger" :show="true"> {{ $t('notActive') }} </b-badge> <br /> <br />
                                                        <template v-if="subscription.payment_provider != 'protokol'">
                                                            <b-button variant="success" @click="activate(subscription.license_code)" class="ml-1"> {{ $t('activate') }} </b-button>
                                                            <div id="tooltip-wrapper" style="float:left">
                                                                <b-button variant="danger" :disabled="!subscription.is_expired"> {{ $t('remove') }} </b-button>
                                                                <b-tooltip target="tooltip-wrapper"> {{ $t('subscriptionCanBeRemovedOnly') }} </b-tooltip>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </template>

                                                <!-- <b-button variant="primary" @click="updateModal.show = true"> Update </b-button>
                                                <b-modal title="Update payment info" v-model="updateModal.show" ok-title="Update" @ok="update">
                                                    <PaymentInfo v-model="updateModal.creditcard" />
                                                </b-modal> -->
                                            </b-col>

                                            <hr />

                                            <b-col xs="12">
                                                <InputField
                                                    type="text"
                                                    name="created_at"
                                                    :label="$t('createdAt')"
                                                    :value="$toUserTimeZone(subscription.CreatedAt)"
                                                    :rules="{}"
                                                    :disabled=true
                                                />

                                                <InputField
                                                    type="text"
                                                    name="renewed_at"
                                                    :label="$t('renewedAt')"
                                                    :value="$toUserTimeZone(subscription.renewed_at)"
                                                    :rules="{}"
                                                    :disabled=true
                                                />

                                                <InputField
                                                    type="text"
                                                    name="expires_at"
                                                    :label="$t('expiresAt')"
                                                    :value="$toUserTimeZone(subscription.expires_at)"
                                                    :rules="{}"
                                                    :disabled=true
                                                />

                                            </b-col>
                                    </div>
                                    <div v-else>
                                        <div v-if="subscription.payment_status == 'pending'" >
                                            <div v-if="subscription.payment_method == 'prepayment'">
                                            {{ $t('waitingForPayment') }}.
                                            </div>

                                            <div v-if="subscription.payment_method == 'creditcard'">
                                            {{ $t('paymentIsInProcess') }}.
                                            </div>
                                        </div>

                                        <div v-if="subscription.payment_status == 'pending_approval'" >
                                            <div v-if="subscription.payment_method == 'creditcard'">
                                            {{ $t('pendingApproval') }}.
                                            </div>
                                        </div>


                                        <div v-if="subscription.payment_status == 'failed'">
                                        {{ $t('paymentFailed') }}.

                                            <br />
                                            <br />

                                            <b-button variant="primary" @click="subModal.show = true" v-if="subscription.payment_status == 'failed'">

                                            {{ $t('subscribe') }}

                                            </b-button>
                                        </div>

                                        <div v-if="subscription.payment_status == 'system_init'">
                                        {{ $t('yourAccount') }} {{ subscription.account.name }}  {{ $t('isReady') }}.

                                            <br />
                                            <br />

                                            <b-button variant="primary" @click="systemInitModal()">

                                            {{ $t('proceed') }}

                                            </b-button>
                                        </div>
                                    </div>
                        </b-col>
                        </b-row>
                        </b-card>
                    </b-col>
                </b-row>

            </div>
            <div v-else>

              {{ $t('notSubscribed') }}.

                <br />
                <br />

            </div>

            <b-modal title="Subscribe" v-model="subModal.show" ok-title="Proceed" @ok="proceed">
                <SelectField :label="this.$t('ChooseSubscription')" v-model="subModal.data.account_uuid" :rules={} :items="packages" v-if="!isSystemInit"/>
                <div v-else>
                    <InputField
                        type="text"
                        name="account"
                        :label="this.$t('account')"
                        :value="subscription.account.name"
                        :rules="{}"
                        :disabled=true
                    />
                </div>

                <b-form-group
                    v-if="isLifetime"
                    :label-cols="0"
                    :horizontal="true">
                  {{ $t('lifeTimeAccount') }}.
                </b-form-group>

                <b-form-group
                    v-if="!isLifetime"
                    :label="this.$t('annually')"
                    label-for="is_annual"
                    :label-cols="2"
                    :horizontal="true">
                    <c-switch class="mx-1" color="success" variant="pill" v-model="subModal.data.isAnnual"/>
                </b-form-group>

                <b-form-group
                    :label="this.$t('paymentMethod')"
                    label-for="payment_method"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-radio-group id="payment_method"
                    v-model="subModal.data.paymentMethod"
                    >
                        <b-form-radio value="creditcard">{{ $t('creditCard') }}</b-form-radio>
                        <b-form-radio value="prepayment" v-if="subModal.data.isAnnual && settings.is_prepayment_allowed">{{ $t('prepayment') }}</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-modal>
            <b-modal title="Payment" v-model="subModal.paymentModal" ok-title="Subscribe" @ok="subscribe" :ok-disabled="paymentInProcess" :cancel-disabled="paymentInProcess">
                <PaymentInfo v-if="subModal.data.paymentMethod == 'creditcard'" v-model="subModal.creditcard" :busy="paymentInProcess"/>

                <span v-if="tdsInProcess"> {{ $t('waitingSecurity') }}... </span>

                <template v-if="subModal.data.paymentMethod == 'prepayment'">
                  {{ $t('confirmSubscription') }}.
                </template>

                <template v-if="!paymentInProcess">
                    <b>{{ $t('total') }}</b>: <span v-if="summary.total">${{ summary.total }}</span> <b-spinner v-else /> <br />
                    <small> {{ $t('priceDoesNotVat') }} </small>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import { Switch as cSwitch } from '@coreui/vue'
import PaymentInfo from './PaymentInfo'
import { groupBy } from 'lodash'

export default {
    name: 'Subscription',
    components: {
        InputField: Input,
        SelectField: Select,
        cSwitch,
        PaymentInfo
    },
    props: {
        settings: {
            type: Object
        }
    },
    data: function() {
        return {
            tdsInProcess: false,
            canDisplaySubscription: false,
            isSystemInit: false,
            subModal: {
                show: false,
                data: {
                    account_uuid: '',
                    paymentMethod: "creditcard",
                    isAnnual: true
                },name: '',
                type: '',
                components: 0,
                base_price: 0,
                api_requests: null,
                media_storage: null,
                is_lifetime: false,
                is_private: false,
                is_subscription: false,
                paymentModal: false,
                creditcard: {
                    name: '',
                    number: '',
                    expires: '',
                    cvv: ''
                }
            },
            paymentInProcess: false,
            packages: [],
            summary: {
                total: null,
                discount: 0
            },
            paymentInfo: null,
            updateModal: {
                show: false,
                creditcard: {
                    name: '',
                    number: '',
                    expires: '',
                    cvv: ''
                }
            }
        }
    },

    computed: {
        subscriptions: {
            get() {
                return this.$store.getters.getSubscriptions
            },

            set(val) {
                this.$store.commit('SET_SUBSCRIPTIONS', val)
            }

        },

        groupedSubscriptions() {
            return groupBy(this.subscriptions.filter(f => {
                return f.license_code
            }), "ref_no")
        },

        isLifetime() {
            let pack = this.packages.find(p => {
               return p.value == this.subModal.data.account_uuid
           })

           if (pack !== undefined) {
                return pack.isLifetime
           }

           return false
        }
    },

    methods: {
        proceed() {
            this.subModal.paymentModal = true

            let isAnnual = this.subModal.data.isAnnual;
            if (this.isLifetime) {
                isAnnual = false
            }

            this.$transactionApi.post("/calculate_price", {uuid: this.subModal.data.account_uuid, is_annual: isAnnual}).then(resp => {
                this.summary.total = resp.data.price / 100
                this.summary.discount = resp.data.discount
            }).catch(err => {
                 this.$bvModal.msgBoxOk(this.$t('somethingUnexpectedHappened'));
                 this.subModal.paymentModal = false
            })
        },

        cancel(licenseCode) {
            this.$bvModal.msgBoxConfirm(this.$t('cancelSubscription')).then(resp => {
                if (resp) {
                    this.$transactionApi.post("/subscription/disable/" + licenseCode).then(resp => {
                        this.subscription.is_canceled = true;
                        this.subscription.is_active = false;
                    }).catch(err => {
                        this.$bvModal.msgBoxOk(this.$t('somethingUnexpectedHappened'));
                    })
                }
            })
        },

        activate(licenseCode) {
            this.$transactionApi.post("/subscription/enable/" + licenseCode).then(resp => {
                this.subscription.is_canceled = false;
                this.subscription.is_active = true;
            }).catch(err => {
                 this.$bvModal.msgBoxOk(this.$t('somethingUnexpectedHappened'));
            })
        },

        renew(licenseCode) {
            this.$transactionApi.post("/subscription/renew/" + licenseCode, {is_annual: false}).then(resp => {
                //this.subscription.is_active = true;
                //console.log(resp.data)
            }).catch(err => {
                 this.$bvModal.msgBoxOk(err.response.data.message);
            })
        },

        remove(licenseCode) {
            this.$transactionApi.post("/subscription/remove/" + licenseCode).then(resp => {
                this.subscription = null
            }).catch(err => {
                this.$bvModal.msgBoxOk(this.$t('somethingUnexpectedHappened'));
            })
        },

        systemInitModal() {
            this.subModal.show = true
            this.isSystemInit = true

            if (this.subscription.period != 12) {
                this.subModal.data.isAnnual = false
            }

            this.subModal.data.account_uuid = this.subscription.account_uuid
        },

        subscribe(e) {
            e.preventDefault();

            this.paymentInProcess = true;

            var data = {
                account_uuid: this.subModal.data.account_uuid,
                payment_method: this.subModal.data.paymentMethod,
                is_annual: this.subModal.data.isAnnual,
                payment_info: {}
            }

            if (this.subModal.data.paymentMethod == 'creditcard') {
                data.payment_info.creditcard = this.subModal.creditcard
            }

            this.$transactionApi.post("/billing/subscription", data).then(resp => {
                this.subscription = resp.data
                this.paymentInProcess = false

                this.$emit("subscribed", this.subscription)

                this.$bvModal.msgBoxOk(this.$t('purchaseSuccessful'));
                this.subModal.show = false;
            }).catch(err => {
                this.paymentInProcess = false

                if (err.response !== undefined) {
                    if (err.response.status == 406) {
                        this.$bvModal.msgBoxOk(this.$t('failedOrder'))
                        return
                    }

                    // this means payment is 3ds and we need to redirect user to another page
                    if (err.response.status == 308) {
                        let data = err.response.data
                        let params = new URLSearchParams(data.Params)
                        let href = data.Href + "?" + params

                        window.open(href, "_blank")

                        this.tdsInProcess = true
                        this.paymentInProcess = true

                        // create pooling to detect what happened to subscription
                        let waitingTime = 0
                        let checkStatus = setInterval(() => {
                            this.$store.dispatch("fetchSubscriptions").then(resp => {
                                if (resp.payment_status !== "failed") {
                                    this.tdsInProcess = false;
                                    this.paymentInProcess = false;

                                    clearInterval(checkStatus)
                                }
                            })

                            if (waitingTime >= 10) {
                                clearInterval(checkStatus)
                                this.tdsInProcess = false;
                                this.paymentInProcess = false;

                                this.subModal.paymentModal = false;
                            }

                            waitingTime++
                        }, 3000)

                        return
                    }
                }

                this.$bvModal.msgBoxOk(this.$t('somethingUnexpectedHappened'))
            })
        },

        getChargeTotal() {
           let pack = this.packages.find(p => {
               return p.value == this.subModal.data.account_uuid
           })

           if (pack !== undefined) {
                return pack.basePrice
           }

           return "0"
        },

        canCancel(subscription) {
            return subscription.is_active && subscription.payment_provider !== "protokol"
        },

        canRenew(subscription) {
            return subscription.is_expired && subscription.payment_provider !== "protokol"
        },

        canRemove(subscription) {
            return subscription.is_expired && subscription.payment_provider !== "protokol"
        }
    },

    mounted() {
        this.$http.get("/v1/user/register/accounts").then(resp => {
            this.packages = resp.data.filter(d => {
                return d.is_subscription
            }).map(d => {
                return {
                    text: d.name,
                    value: d.uuid,
                    basePrice: (d.base_price / 100).toString(),
                    isLifetime: d.is_lifetime,
                }
            })


        }).catch(err => {
            console.log(err)
        })

        this.$store.dispatch("fetchSubscriptions")

        // this.$store.dispatch("fetchSubscriptionPaymentInfo").then(data => {
        //     this.paymentInfo = data;
        // })
    }
}
</script>
